import React from "react";
import { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { Navigate, useNavigate, useOutletContext,Link } from "react-router-dom";
import { useSelector } from "react-redux";
import MembGameSvcMnyDpstLstInqApi from "Apis/MembGameSvcMnyDpstLstInqApi";
import Pagination from "react-js-pagination";
import GameSvcSelectWithDatePicker from "Components/GameSvcSelectWithDatePicker";
import MembGameSvcMnyInqUi from "./MembGameSvcMnyInqUi";
import { getDefaultDateRange, useModalBodyScroll } from "./orderListCommon";
import MgpStore from "Stores/Store";


const MembGameSvcMnyDpstLstUi = () => {
    const langData:any = useOutletContext();
    const navigate = useNavigate();
    const idntMthdCd = useSelector((state: any) => state.IdntMthdCdState?.IdntMthdCd);
    const [pageState, setPageState] = useState(1);
    const [onePageSizeState,setOnePageSizeState] = useState();
    const [totPstdCntState,setTotPstdCntState] = useState(1);
    const [dpstOdrLstState,setDpstOdrLstState] = useState<any>();
    const [selectedSvcCdState,setselectedSvcCdState] = useState("");
    const [selectedSvcNmState,setselectedSvcNmState] = useState<any>(langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");
    const [mdalState,setmdalState] = useState(false);
    const [currentStartDate, setCurrentStartDate] = useState("");
    const [currentEndDate, setCurrentEndDate] = useState("");
    useEffect(() => {
            if (idntMthdCd === 'NA') {
                navigate('/MyPage/IdntMthdChng', { replace: true });
                return;
            }
        }, [idntMthdCd, navigate]);

    useModalBodyScroll(mdalState);

    const handlePageChange = (newPageState:any) => {
        setPageState(newPageState);
        
        // 현재 선택된 날짜 범위 사용
        MembGameSvcMnyDpstLstInqApi(selectedSvcCdState, newPageState, currentStartDate, currentEndDate)
        .then((resp)=>{
            setDpstOdrLstState(resp.apiBody.dpstOdrLst);
            setPageState(resp.apiBody.nowPageNo);
            setOnePageSizeState(resp.apiBody.onePageSize);
            setTotPstdCntState(resp.apiBody.totCnt);
        })
      };
    const MdalOpenerFunc =(e:string|null) => {
        setmdalState((prev) => !prev);
    }

    // GameSvcSelectWithDatePicker에서 게임 서비스가 변경될 때 호출
    const handleGameServiceChange = (gameSvcCd: string, gameNm: string) => {
        setselectedSvcCdState(gameSvcCd);
        setselectedSvcNmState(gameNm);
        // 날짜는 handleDateChange에서 처리됨
    };

    // GameSvcSelectWithDatePicker에서 날짜가 변경될 때 호출
    const handleDateChange = (startDate: string, endDate: string, gameSvcCd?: string) => {
        // 현재 날짜 범위 저장
        setCurrentStartDate(startDate);
        setCurrentEndDate(endDate);
        
        // 전달받은 gameSvcCd를 우선 사용, 없으면 state 사용
        const currentGameSvcCd = gameSvcCd || selectedSvcCdState;
        
        if (currentGameSvcCd) {
            MembGameSvcMnyDpstLstInqApi(currentGameSvcCd, 1, startDate, endDate)
            .then((resp)=>{
                setDpstOdrLstState(resp.apiBody.dpstOdrLst);
                setPageState(resp.apiBody.nowPageNo);
                setOnePageSizeState(resp.apiBody.onePageSize);
                setTotPstdCntState(resp.apiBody.totCnt);
            });
        }
    };

    // 초기화 useEffect 추가
    useEffect(()=>{
        setselectedSvcCdState("MGP");
        setselectedSvcNmState(langData?.MYPAGE_SELT_VAL_ALL_DESC_00 || "전체");
        
        const { startDateStr, endDateStr } = getDefaultDateRange();
        setCurrentStartDate(startDateStr);
        setCurrentEndDate(endDateStr);
        
        MembGameSvcMnyDpstLstInqApi("MGP", pageState, startDateStr, endDateStr)
        .then((resp)=>{ 
            setDpstOdrLstState(resp.apiBody.dpstOdrLst);
            setPageState(resp.apiBody.nowPageNo);
            setOnePageSizeState(resp.apiBody.onePageSize);
            setTotPstdCntState(resp.apiBody.totCnt);
        });
    },[MgpStore.getState().LangSetState.Lang]); // 언어팩이 변경될 때마다 초기화
    
    return(
        <>
        <Helmet>
            <title>{`${process.env.REACT_APP_TITLE_PREFIX} ${langData&&langData.MYPAGE_MENU_MNY_LST_BTN_00}`}</title>
        </Helmet>
        <div className="container1300 BgW pb200">
            <div className="myPageSubTitlWrap">
                <p className="myPageCtxtTitl">{langData&&langData.MYPAGE_MENU_MNY_LST_BTN_00}</p>
            </div>
            {/* OTP 설정 */}
            <div>
                <div className="myGameSvcMnyCtgrMenu">
                    <ul>
                        <li className="active">
                            <Link to="/MyPage/GameSvcMnyDpstLst">
                                <p>{langData&&langData.MYPAGE_MNY_LST_DPST_BTN_01}</p>
                            </Link>
                        </li>
                        <li>
                            <Link to="/MyPage/GameSvcItemOdrLst">
                                <p>{langData&&langData.MYPAGE_MNY_LST_PRCH_BTN_00}</p>
                            </Link>
                        </li>
                        {/* <li>
                            <Link to="/MyPage/GameSvcGiftOdrLst">
                               <p>{langData&&langData.MYPAGE_MNY_LST_GIFT_BTN_00}</p>
                            </Link>
                        </li> */}
                    </ul>
                </div>
                <div className="myGameSvcMnyCtxtWrap">
                    <div className="myGameSvcMnyTopWrap">
                        <GameSvcSelectWithDatePicker
                            langData={langData}
                            selectedSvcCdState={selectedSvcCdState}
                            selectedSvcNmState={selectedSvcNmState}
                            onGameServiceChange={handleGameServiceChange}
                            onDateChange={handleDateChange}
                            navigate={navigate}
                        />
                        <div className="GameSvcMnyBtnWrap">
                            <button onClick={()=>MdalOpenerFunc(null)}>{langData&&langData.MYPAGE_MAIN_MNY_DPST_BTN_01}</button>
                        </div>
                    </div>
                    <div className="myGameSvcMnydpstOdrLstWrap">
                        <ul className="dpstOdrLstUl">
                            <li className="lstTItlWrap fr6 moNone">
                                <p className="ctntTitlTxt dpstOdrGameTitl">{langData&&langData.MYPAGE_MNY_LST_CTQR_LBL_00}</p>
                                <p className="dpstOdr">{langData&&langData.MYPAGE_MNY_LST_CTQR_LBL_01}</p>
                                <p className="dpstOdr">{langData&&langData.MYPAGE_MNY_LST_CTQR_LBL_02}</p>
                                <p className="dpstOdr">{langData&&langData.MYPAGE_MNY_LST_CTQR_LBL_05}</p>
                                <p className="dpstOdr">{langData&&langData.MYPAGE_MNY_LST_CTQR_LBL_03}</p>
                                <p className="dpstOdr">{langData&&langData.MYPAGE_MNY_LST_CTQR_LBL_04}</p>
                            </li>
                            {dpstOdrLstState&&dpstOdrLstState.length != 0  ? 
                                <>
                                    {dpstOdrLstState&&dpstOdrLstState.map((key:any, index:number) => (
                                        <li key={index} className=" fr6">
                                            <p className="ctntTitlTxt dpstOdrGameTitl">{key.gameNm}</p>
                                            <p className="dpstOdrMthdNm">{key.pymtMthdNm}</p>
                                            <p className="dpstOdrAmt">{key.odrAmt}</p>
                                            <p className="dpstOdrAmt">{key.odrMny}</p>
                                            <p className="dpstOdrSttuNm">{key.odrSttuNm}</p>
                                            <p className="dpstOdrDtime">{key.odrDtime}</p>
                                        </li>
                                    ))}
                                </>:
                                <li  className="noDataLi">
                                    <p>{langData&&langData.MYPAGE_MNY_LST_NO_DATA_00}</p>
                                </li>
                            }
                        </ul>
                        {dpstOdrLstState&&dpstOdrLstState.length != 0  ? 
                            <div className="ctntPageWrap">
                                <Pagination
                                    activePage={pageState}
                                    itemsCountPerPage={onePageSizeState}
                                    totalItemsCount={totPstdCntState}
                                    pageRangeDisplayed={5}
                                    firstPageText={""}
                                    linkClassFirst={"pagenationBtn pagenationFirstBtn"}
                                    prevPageText={""}
                                    linkClassPrev={"pagenationBtn pagenationPrevBtn"}
                                    nextPageText={""}
                                    linkClassNext={"pagenationBtn pagenationNextBtn"}
                                    lastPageText={""}
                                    linkClassLast={"pagenationBtn pagenationLastBtn"}
                                    onChange={handlePageChange}
                                />
                            </div>:
                            <></>
                        }
                    </div>
                </div>
            </div>
        </div>
        {mdalState&&(
            <div className="mdalWrap dpstLpop">
                <div className="mdalBg" onClick={()=>MdalOpenerFunc(null)}></div>
                <div className="mdalCtxtWrap contaniner700 mdalCommContainer">
                    <MembGameSvcMnyInqUi></MembGameSvcMnyInqUi>
                    <div className="dpstLstMdalClose">
                        <button  className="mdalCloseBtn"onClick={() => MdalOpenerFunc(null)}>
                            <p>{langData&&langData.COMM_MAIN_CHK_MAIN_BTN_00}</p>
                        </button>
                    </div>
                </div>
            </div>
        )}
        {/* {ntcMdalState && (
            <MdalCommUi mdalType={"modalType01"} mdalCtxtTitl={"회원 탈퇴 주의사항을 확인해 주세요."} mdalSize={"w500"} mdalFunc={NtcMdalOpenerFunc(null)} />
            // MYPAGE_MEMB_LVD_LPOP_DESC_00
        )} */}
        </>
        
    )
}

export default MembGameSvcMnyDpstLstUi;